<template>
    <v-card>
        <v-card-title>
            Delete Hall of Fame group
        </v-card-title>

        <v-card-text>
            Confirm deletion of group {{ group.name }}?
        </v-card-text>

        <v-card-actions>
            <v-spacer />
            <v-btn color="primary" @click="$emit('close')">
                Close
            </v-btn>
            <v-btn color="warning" @click="$emit('submit', $event, group)">
                Delete
            </v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
export default {
    props: {
        group: Object,
    },
};
</script>
